export const PlusIcon = ({
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden='true'
  >
    <mask
      id='path-1-outside-1_87_5298'
      maskUnits='userSpaceOnUse'
      x='-0.373047'
      y='-0.297852'
      width='14'
      height='14'
      fill='black'
    >
      <rect fill='white' x='-0.373047' y='-0.297852' width='14' height='14' />
      <path d='M11.2519 5.58215V7.88615L8.1199 7.86815V11.2701H5.6359V7.85015L1.9999 7.83215V5.52815L5.6359 5.54615V2.00015H8.1199V5.56415L11.2519 5.58215Z' />
    </mask>
    <path
      d='M11.2519 5.58215V7.88615L8.1199 7.86815V11.2701H5.6359V7.85015L1.9999 7.83215V5.52815L5.6359 5.54615V2.00015H8.1199V5.56415L11.2519 5.58215Z'
      fill='white'
    />
    <path
      d='M11.2519 5.58215H13.2519C13.2519 4.48207 12.3635 3.5885 11.2634 3.58218L11.2519 5.58215ZM11.2519 7.88615L11.2404 9.88612C11.7728 9.88918 12.2845 9.67982 12.662 9.30442C13.0396 8.92902 13.2519 8.41857 13.2519 7.88615H11.2519ZM8.1199 7.86815L8.13139 5.86818C7.59898 5.86512 7.08732 6.07448 6.70975 6.44988C6.33219 6.82527 6.1199 7.33572 6.1199 7.86815H8.1199ZM8.1199 11.2701V13.2701C9.22447 13.2701 10.1199 12.3747 10.1199 11.2701H8.1199ZM5.6359 11.2701H3.6359C3.6359 12.3747 4.53133 13.2701 5.6359 13.2701V11.2701ZM5.6359 7.85015H7.6359C7.6359 6.74944 6.74649 5.85562 5.6458 5.85017L5.6359 7.85015ZM1.9999 7.83215H-0.000101507C-0.000101507 8.93285 0.889306 9.82668 1.99 9.83212L1.9999 7.83215ZM1.9999 5.52815L2.0098 3.52817C1.47766 3.52554 0.966406 3.73508 0.58919 4.11044C0.211974 4.48579 -0.000101507 4.996 -0.000101507 5.52815H1.9999ZM5.6359 5.54615L5.626 7.54612C6.15814 7.54876 6.66939 7.33921 7.04661 6.96386C7.42382 6.5885 7.6359 6.0783 7.6359 5.54615H5.6359ZM5.6359 2.00015V0.00014782C4.53133 0.00014782 3.6359 0.895578 3.6359 2.00015H5.6359ZM8.1199 2.00015H10.1199C10.1199 0.895578 9.22447 0.00014782 8.1199 0.00014782V2.00015ZM8.1199 5.56415H6.1199C6.1199 6.66423 7.00834 7.55779 8.1084 7.56411L8.1199 5.56415ZM11.2519 5.58215H9.2519V7.88615H11.2519H13.2519V5.58215H11.2519ZM11.2519 7.88615L11.2634 5.88618L8.13139 5.86818L8.1199 7.86815L8.1084 9.86811L11.2404 9.88612L11.2519 7.88615ZM8.1199 7.86815H6.1199V11.2701H8.1199H10.1199V7.86815H8.1199ZM8.1199 11.2701V9.27015H5.6359V11.2701V13.2701H8.1199V11.2701ZM5.6359 11.2701H7.6359V7.85015H5.6359H3.6359V11.2701H5.6359ZM5.6359 7.85015L5.6458 5.85017L2.0098 5.83217L1.9999 7.83215L1.99 9.83212L5.626 9.85012L5.6359 7.85015ZM1.9999 7.83215H3.9999V5.52815H1.9999H-0.000101507V7.83215H1.9999ZM1.9999 5.52815L1.99 7.52812L5.626 7.54612L5.6359 5.54615L5.6458 3.54617L2.0098 3.52817L1.9999 5.52815ZM5.6359 5.54615H7.6359V2.00015H5.6359H3.6359V5.54615H5.6359ZM5.6359 2.00015V4.00015H8.1199V2.00015V0.00014782H5.6359V2.00015ZM8.1199 2.00015H6.1199V5.56415H8.1199H10.1199V2.00015H8.1199ZM8.1199 5.56415L8.1084 7.56411L11.2404 7.58212L11.2519 5.58215L11.2634 3.58218L8.13139 3.56418L8.1199 5.56415Z'
      fill='black'
      mask='url(#path-1-outside-1_87_5298)'
    />
  </svg>
);
